<script>import "./CarbonChartsStyles.css";
import { BarChartStacked } from "@carbon/charts-svelte";
import { ScaleTypes } from "@carbon/charts-svelte";
export let data;
export let title;
export let height;
export let getChartsSharedOptions;
let specificOptions = {
  axes: {
    left: {
      mapsTo: "value",
      stacked: true
    },
    bottom: {
      mapsTo: "date",
      scaleType: ScaleTypes.TIME
    }
  }
};
$: options = { ...specificOptions, ...getChartsSharedOptions(data, title, height) };
</script>

<svelte:component this={BarChartStacked} {data} {options} />
